import { CheckIcon } from '@heroicons/react/24/solid'
import { forwardRef, useImperativeHandle, useState } from 'react'
import { P3 } from '@/frontend/design-system/typography/Paragraph'

export type ToastHandle = {
  show: () => void
}

export const Toast = forwardRef<ToastHandle>((_props, ref) => {
  const [visible, setVisible] = useState<boolean>(false)

  useImperativeHandle(
    ref,
    () => ({
      show: () => {
        setVisible(true)
        setTimeout(() => setVisible(false), 2000)
      }
    }),
    []
  )

  if (!visible) return null

  return (
    <div className='absolute -top-12 left-1/2 z-50 flex w-[90%] -translate-x-1/2 gap-2 rounded-md border border-contentBlue bg-backgroundBlue p-2 shadow-lg sm:w-sm'>
      <CheckIcon className='h-5 w-5 text-contentBlue' />
      <P3 className='text-contentBlue'>Sformatowano tekst.</P3>
    </div>
  )
})

Toast.displayName = 'Toast'
